import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const messages = {
  it: {},
  en: {}
}
export default new VueI18n({
  locale: sessionStorage.getItem('lang'), // set locale
  fallbackLocale: 'it', // default lang
  messages, // set locale messages
  silentTranslationWarn: true
})



// WEBPACK FOOTER //
// ./src/translation/Index.js